import React from 'react';
import Tile from '../Tile/Tile';
import { tilesListPropTypes } from './TilesListPropTypes';
import * as styles from './TilesList.module.scss';
const TilesList = ({
  heading,
  classname,
  external,
  items
}) => {
  if (!heading && !items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || null}`
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), items && /*#__PURE__*/React.createElement("ol", {
    className: styles.rootList
  }, items.map((item, index) => /*#__PURE__*/React.createElement(Tile, Object.assign({
    external: external
  }, item, {
    key: index
  })))));
};
export default TilesList;